import request from '@/utils/request'

export function getprovince(){
    return request({
        url: 'address/get-province',
        method: 'get'
    })
}

export function getcity(data){
    return request({
        url: 'address/get-city',
        method: 'get',
        params: data
    })
}

export function getcounty(data){
    return request({
        url: 'address/get-county',
        method: 'get',
        params: data
    })
}

export function gettown(data){
    return request({
        url: 'address/get-town',
        method: 'get',
        params: data
    })
}

export function addaddress(data){
    return request({
        url: 'user/add-address',
        method: 'post',
        data:data
    })
}

export function editaddress(data){
    return request({
        url: 'user/edit-address',
        method: 'post',
        data:data
    })
}

export function deleteaddress(data){
    return request({
        url: 'user/delete-address',
        method: 'post',
        data:data
    })
}

export function addresslist(data){
    return request({
        url: 'user/get-address-list',
        method: 'get',
        params: data
    })
}

export function addressinfo(data){
    return request({
        url: 'user/get-address-info',
        method: 'get',
        params: data
    })
}

export function getDefaultAddress(){
    return request({
        url: 'user/get-default-address-info',
        method: 'get'
    })
}

export function getAddressInfo(data){
    return request({
        url: 'user/get-address-info',
        method: 'get',
        params: data
    })
}
